import { useState } from 'react';

export const useResData = () => {
  const [resData, setResData] = useState<{
    weight: number | string;
    gluten: number | string;
    idk: number | string;
    bug: number | string;
    protein: number | string;
    cp: number | string;
    nature: number | string;
    humidity: number | string;
    temperature: number | string;
    wheatType: number | string;
  }>({
    weight: 0,
    gluten: 0,
    idk: 0,
    bug: 0,
    protein: 0,
    cp: 0,
    nature: 0,
    humidity: 0,
    temperature: 0,
    wheatType: 0,
  });

  return { resData, setResData };
};
